module.exports = __webpack_public_path__ + "static/media/hall-P7.0e082030.svg";